/**
 * ProcessAutostartIndicator — plakietka „Proces się uruchamia…" obok banera akceptacji na karcie
 * rekordu. Pokazuje się, gdy `useRecordProcessAutostart` uzbroił poll po zapisie z automatyzacją
 * `start_approval`; znika sama (żywa sprawa albo limit czasu). Wspólna dla kart kontrahenta,
 * zadania i rekordu modułu własnego.
 */

import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Spinner } from '@/components/Spinner';

export interface ProcessAutostartIndicatorProps {
  /** `starting` z `useRecordProcessAutostart`. */
  starting: boolean;
}

export function ProcessAutostartIndicator({
  starting,
}: ProcessAutostartIndicatorProps): ReactElement | null {
  const { t } = useTranslation();
  if (!starting) return null;
  return (
    <span
      className="inline-flex shrink-0 items-center gap-1.5 rounded-full bg-bg-tertiary px-2.5 py-1 text-xs font-medium text-text-secondary"
      data-testid="process-autostart-indicator"
    >
      <Spinner size="sm" />
      {t('tenant.processes.autostart.starting')}
    </span>
  );
}
